import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileText, ImagePlus, Loader2, Trash2, Upload } from "lucide-react";
import { api, errMsg, media } from "@/lib/api";

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

export const ImageUpload = ({ value, onChange, testid = "image-upload", accept = "image/*", pdf = false }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onChange(await uploadFile(file));
      toast.success("Uploaded");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <div className="w-28 h-20 rounded-md border border-stone-200 bg-stone-50 flex items-center justify-center overflow-hidden shrink-0" data-testid={`${testid}-preview`}>
        {value ? (pdf ? <FileText className="w-8 h-8 text-crimson" /> : <img src={media(value)} alt="" className="w-full h-full object-contain" />) : <ImagePlus className="w-6 h-6 text-stone-300" />}
      </div>
      <div className="flex flex-col gap-2 min-w-0">
        <div className="flex gap-2">
          <button type="button" onClick={() => input.current?.click()} disabled={busy} className="inline-flex items-center gap-1.5 text-sm border border-stone-300 rounded-md px-3 py-1.5 hover:bg-stone-50 disabled:opacity-50" data-testid={`${testid}-button`}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}{value ? "Replace" : "Upload"}
          </button>
          {value && (
            <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-1 text-sm text-red-600 border border-red-200 rounded-md px-3 py-1.5 hover:bg-red-50" data-testid={`${testid}-remove`}>
              <Trash2 className="w-4 h-4" />Remove
            </button>
          )}
        </div>
        {value && pdf && <a href={media(value)} target="_blank" rel="noreferrer" className="text-xs text-crimson underline truncate">View current file</a>}
      </div>
      <input ref={input} type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
};
